<div class="step-wrap same-line" [ngClass]="{'current-step': isCurrent}">
	<div class="step-number">{{stepNum}}</div>
	<div class="step-label">{{stepLabel}}</div>
</div>